// extracted by mini-css-extract-plugin
module.exports = {"dialogBody":"AddGroupDialog_dialogBody__1tCwR","playerInvitor":"AddGroupDialog_playerInvitor__ql6rM"};